import React from 'react';
import { Card, Row, Col, Typography, Empty } from 'antd';
import { Container } from 'react-bootstrap';
import TechnicalChart from './TechnicalChart';
import usePageTracking from '../utils/usePageTracking';

const { Title } = Typography;

const TechnicalChartsPage = ({ screeningResults }) => {
  // GA4 页面追踪
  usePageTracking('技術分析圖表');
  // 過濾出有價格數據的股票
  const stocksWithPriceData = screeningResults.filter(stock => 
    stock.stock_price_data && stock.stock_price_data.length > 0
  );

  // 沒有篩選結果的情況
  if (!screeningResults || screeningResults.length === 0) {
    return (
      <Container fluid className="mt-4">
        <Card>
          <div style={{ textAlign: 'center', padding: '40px 0' }}>
            <Empty 
              description="沒有篩選結果"
              image={Empty.PRESENTED_IMAGE_SIMPLE}
            />
            <p>請先執行篩選功能獲取股票數據</p>
          </div>
        </Card>
      </Container>
    );
  }

  // 有篩選結果但沒有價格數據的情況
  if (stocksWithPriceData.length === 0) {
    return (
      <Container fluid className="mt-4">
        <Card>
          <div style={{ textAlign: 'center', padding: '40px 0' }}>
            <Empty 
              description="無法獲取技術分析數據"
              image={Empty.PRESENTED_IMAGE_SIMPLE}
            />
            <p>共 {screeningResults.length} 隻股票符合篩選條件，但暫時無法獲取價格數據</p>
            <p>請稍後再試或聯繫管理員</p>
          </div>
        </Card>
      </Container>
    );
  }

  return (
    <Container fluid className="mt-4">
      <Card>
        <div style={{ marginBottom: '20px' }}>
          <Title level={4}>技術分析圖表</Title>
          <p>共 {screeningResults.length} 隻股票符合篩選條件，其中 {stocksWithPriceData.length} 隻有技術分析數據 （紅色均線為MA100）</p>
        </div>
        
        <Row gutter={[16, 16]}>
          {stocksWithPriceData.map((stock, index) => (
            <Col xs={24} sm={12} md={12} lg={12} xl={12} key={stock.company_symbol}>
              <Card 
                size="small" 
                style={{ 
                  height: '220px',
                  border: '1px solid #e8e8e8',
                  borderRadius: '8px'
                }}
                bodyStyle={{ 
                  padding: '8px',
                  height: '100%'
                }}
              >
                <TechnicalChart 
                  symbol={stock.company_symbol}
                  priceData={stock.stock_price_data}
                  width="100%"
                  height="200px"
                />
              </Card>
            </Col>
          ))}
        </Row>
      </Card>
    </Container>
  );
};

export default TechnicalChartsPage; 
